export interface ProductData {
  iso2s: string[];
  name: string;
  /**
   * Hero H1 region label — used as fallback when user hasn't narrowed via query.
   * Only set on multi-country slugs that map cleanly to one region.
   * Maps to HeroRegionId in helpers.ts.
   */
  regionId?:
    | "asia"
    | "middleEast"
    | "europe"
    | "northAmerica"
    | "latinAmerica"
    | "africa"
    | "oceania";
}

export const oldData: Record<string, ProductData> = {
  "thailand-esim": { "iso2s": ["TH"], "name": "Thailand" },
  "south-east-asia-esim": { "iso2s": ["TH", "VN", "ID", "MY", "SG", "PH", "KH", "LA", "MM", "BN"], "name": "South East Asia", "regionId": "asia" },
  "useurope-esim-2": { "iso2s": ["US", "CA", "GB", "DE", "FR", "IT", "ES", "NL", "CH", "AT", "BE", "PT", "SE", "NO", "DK", "FI", "IE", "PL", "CZ", "HU", "GR", "RO", "BG", "HR", "SI", "SK", "LT", "LV", "EE", "LU", "MT", "CY", "IS", "LI", "MC", "AD", "SM", "VA", "GI", "FO", "GL", "AX", "JE", "GG", "IM", "MQ", "GP", "RE", "YT", "MF", "BL", "PM", "WF", "PF", "NC"], "name": "US and Europe" },
  "japan-esim": { "iso2s": ["JP"], "name": "Japan" },
  "united-states-usa-unlimited-esim": { "iso2s": ["US"], "name": "United States Unlimited" },
  "indonesia-esim": { "iso2s": ["ID"], "name": "Indonesia" },
  "china-esim": { "iso2s": ["CN"], "name": "China" },
  "malaysia-esim": { "iso2s": ["MY"], "name": "Malaysia" },
  "taiwan-esim": { "iso2s": ["TW"], "name": "Taiwan" },
  "portugal-esim": { "iso2s": ["PT"], "name": "Portugal" },
  "turkey-esim": { "iso2s": ["TR"], "name": "Turkey" },
  "australia-esim": { "iso2s": ["AU"], "name": "Australia" },
  "usa-esim": { "iso2s": ["US"], "name": "United States" },
  "asia-esim": { "iso2s": ["JP", "KR", "CN", "HK", "TW", "MO", "TH", "VN", "ID", "MY", "SG", "PH", "IN", "KH", "LA", "MM", "BN", "LK", "BD", "NP", "PK", "KZ", "UZ", "KG", "TJ", "MN", "AE", "SA", "TR", "IL", "QA", "OM", "KW", "BH", "JO", "LB", "IQ"], "name": "Asia", "regionId": "asia" },
  "south-korea-esim": { "iso2s": ["KR"], "name": "South Korea" },
  "israel-esim": { "iso2s": ["IL"], "name": "Israel" },
  "china-macao-hongkong-esim": { "iso2s": ["CN", "MO", "HK"], "name": "China, Macao, and Hong Kong" },
  "vietnam-unlimited-esim": { "iso2s": ["VN"], "name": "Vietnam Unlimited" },
  "united-states-canada-esim": { "iso2s": ["US", "CA"], "name": "United States and Canada", "regionId": "northAmerica" },
  "hongkong-esim": { "iso2s": ["HK"], "name": "Hong Kong" },
  "singapore-malaysia-esim": { "iso2s": ["SG", "MY"], "name": "Singapore and Malaysia" },
  "united-kingdom-esim": { "iso2s": ["GB"], "name": "United Kingdom" },
  "cyprus-esim": { "iso2s": ["CY"], "name": "Cyprus" },
  "canada-esim": { "iso2s": ["CA"], "name": "Canada" },
  "singapore-esim": { "iso2s": ["SG"], "name": "Singapore" },
  "india-esim": { "iso2s": ["IN"], "name": "India" },
  "spain-esim": { "iso2s": ["ES"], "name": "Spain" },
  "nepal-esim": { "iso2s": ["NP"], "name": "Nepal" },
  "australia-new-zealand-esim": { "iso2s": ["AU", "NZ"], "name": "Australia and New Zealand", "regionId": "oceania" },
  "germany-esim": { "iso2s": ["DE"], "name": "Germany" },
  "italy-esim": { "iso2s": ["IT"], "name": "Italy" },
  "georgia-esim": { "iso2s": ["GE"], "name": "Georgia" },
  "france-esim": { "iso2s": ["FR"], "name": "France" },
  "albania-esim": { "iso2s": ["AL"], "name": "Albania" },
  "latin-america-esim": { "iso2s": ["BR", "MX", "AR", "CL", "CO", "PE", "VE", "EC", "UY", "PY", "BO", "CR", "PA", "GT", "HN", "NI", "SV", "DO", "JM", "TT", "BS", "BB", "AG", "LC", "VC", "GD", "DM", "CU", "HT", "BZ", "GY", "SR", "GF", "GP", "MQ", "AW", "CW", "SX", "KY", "BM", "AI", "VG", "TC", "MF", "KN", "MS"], "name": "Latin America", "regionId": "latinAmerica" },
  "global-96-esim-yoho-special-esim": { "iso2s": ["US", "CA", "GB", "DE", "FR", "IT", "ES", "NL", "CH", "AT", "BE", "PT", "SE", "NO", "DK", "FI", "IE", "JP", "KR", "CN", "HK", "TW", "MO", "SG", "MY", "TH", "VN", "ID", "PH", "IN", "AE", "SA", "TR", "IL", "QA", "OM", "KW", "BH", "AU", "NZ", "ZA", "EG", "MA", "KE", "NG", "BR", "MX", "AR", "CL"], "name": "Global 96 Yoho Special" },
  "cambodia-esim": { "iso2s": ["KH"], "name": "Cambodia" },
  "kazakhstan-esim": { "iso2s": ["KZ"], "name": "Kazakhstan" },
  "ghana-esim": { "iso2s": ["GH"], "name": "Ghana" },
  "greece-esim": { "iso2s": ["GR"], "name": "Greece" },
  "guadeloupe-esim": { "iso2s": ["GP"], "name": "Guadeloupe" },
  "netherlands-esim": { "iso2s": ["NL"], "name": "Netherlands" },
  "switzerland-esim": { "iso2s": ["CH"], "name": "Switzerland" },
  "new-zealand-esim": { "iso2s": ["NZ"], "name": "New Zealand" },
  "austria-esim": { "iso2s": ["AT"], "name": "Austria" },
  "poland-esim": { "iso2s": ["PL"], "name": "Poland" },
  "belgium-esim": { "iso2s": ["BE"], "name": "Belgium" },
  "uzbekistan-esim": { "iso2s": ["UZ"], "name": "Uzbekistan" },
  "united-arab-emirates-uae-esim": { "iso2s": ["AE"], "name": "United Arab Emirates" },
  "nordic-esims": { "iso2s": ["SE", "NO", "DK", "FI", "IS", "FO", "GL"], "name": "Nordic Countries" },
  "rwanda-esim": { "iso2s": ["RW"], "name": "Rwanda" },
  "serbia-esim": { "iso2s": ["RS"], "name": "Serbia" },
  "saudi-arabia-esim": { "iso2s": ["SA"], "name": "Saudi Arabia" },
  "egypt-esim": { "iso2s": ["EG"], "name": "Egypt" },
  "tunisia-esim": { "iso2s": ["TN"], "name": "Tunisia" },
  "sri-lanka-esim": { "iso2s": ["LK"], "name": "Sri Lanka" },
  "hungary-esim": { "iso2s": ["HU"], "name": "Hungary" },
  "palestine-esim": { "iso2s": ["PS"], "name": "Palestine" },
  "mozambique-esim": { "iso2s": ["MZ"], "name": "Mozambique" },
  "russia-esim": { "iso2s": ["RU"], "name": "Russia" },
  "south-africa-esim": { "iso2s": ["ZA"], "name": "South Africa" },
  "kyrgyzstan-esim": { "iso2s": ["KG"], "name": "Kyrgyzstan" },
  "ukraine-esim": { "iso2s": ["UA"], "name": "Ukraine" },
  "morocco-esim": { "iso2s": ["MA"], "name": "Morocco" },
  "fiji-esim": { "iso2s": ["FJ"], "name": "Fiji" },
  "pakistan-esim": { "iso2s": ["PK"], "name": "Pakistan" },
  "faroe-islands-esim": { "iso2s": ["FO"], "name": "Faroe Islands" },
  "timor-leste-esim": { "iso2s": ["TL"], "name": "Timor-Leste" },
  "iceland-esim": { "iso2s": ["IS"], "name": "Iceland" },
  "bulgaria-esim": { "iso2s": ["BG"], "name": "Bulgaria" },
  "montenegro-esim-2": { "iso2s": ["ME"], "name": "Montenegro" },
  "denmark-esim": { "iso2s": ["DK"], "name": "Denmark" },
  "jersey-esim": { "iso2s": ["JE"], "name": "Jersey" },
  "peru-esim": { "iso2s": ["PE"], "name": "Peru" },
  "palau-esim": { "iso2s": ["PW"], "name": "Palau" },
  "czech-republic-esim": { "iso2s": ["CZ"], "name": "Czech Republic" },
  "azerbaijan-esim": { "iso2s": ["AZ"], "name": "Azerbaijan" },
  "sweden-esim": { "iso2s": ["SE"], "name": "Sweden" },
  "martinique-esim": { "iso2s": ["MQ"], "name": "Martinique" },
  "philippines-esim": { "iso2s": ["PH"], "name": "Philippines" },
  "mexico-esim": { "iso2s": ["MX"], "name": "Mexico" },
  "namibia-esim": { "iso2s": ["NA"], "name": "Namibia" },
  "croatia-esim": { "iso2s": ["HR"], "name": "Croatia" },
  "tajikistan-esim": { "iso2s": ["TJ"], "name": "Tajikistan" },
  "armenia-esim": { "iso2s": ["AM"], "name": "Armenia" },
  "malta-esim": { "iso2s": ["MT"], "name": "Malta" },
  "bangladesh-esim": { "iso2s": ["BD"], "name": "Bangladesh" },
  "bahamas-esim": { "iso2s": ["BS"], "name": "Bahamas" },
  "romania-esim": { "iso2s": ["RO"], "name": "Romania" },
  "reunion-esim": { "iso2s": ["RE"], "name": "Reunion" },
  "montenegro-esim": { "iso2s": ["ME"], "name": "Montenegro" },
  "moldova-esim": { "iso2s": ["MD"], "name": "Moldova" },
  "iraq-esim": { "iso2s": ["IQ"], "name": "Iraq" },
  "norway-esim": { "iso2s": ["NO"], "name": "Norway" },
  "bhutan-esim": { "iso2s": ["BT"], "name": "Bhutan" },
  "ireland-esim": { "iso2s": ["IE"], "name": "Ireland" },
  "costa-rica-esim": { "iso2s": ["CR"], "name": "Costa Rica" },
  "macedonia-esim": { "iso2s": ["MK"], "name": "Macedonia" },
  "ethiopia-esim": { "iso2s": ["ET"], "name": "Ethiopia" },
  "aruba-esim": { "iso2s": ["AW"], "name": "Aruba" },
  "venezuela-esim": { "iso2s": ["VE"], "name": "Venezuela" },
  "republic-of-the-congo-esim": { "iso2s": ["CG"], "name": "Republic of the Congo" },
  "finland-esim": { "iso2s": ["FI"], "name": "Finland" },
  "algeria-esim": { "iso2s": ["DZ"], "name": "Algeria" },
  "zambia-esim": { "iso2s": ["ZM"], "name": "Zambia" },
  "nigeria-esim": { "iso2s": ["NG"], "name": "Nigeria" },
  "kenya-esim": { "iso2s": ["KE"], "name": "Kenya" },
  "qatar-esim": { "iso2s": ["QA"], "name": "Qatar" },
  "slovenia-esim": { "iso2s": ["SI"], "name": "Slovenia" },
  "middle-east-esim": { "iso2s": ["AE", "SA", "TR", "IL", "QA", "OM", "KW", "BH", "JO", "LB", "IQ", "IR", "YE", "SY"], "name": "Middle East" },
  "u-s-virgin-islands-esim": { "iso2s": ["VI"], "name": "U.S. Virgin Islands" },
  "guam-esim": { "iso2s": ["GU"], "name": "Guam" },
  "dominican-republic-esim": { "iso2s": ["DO"], "name": "Dominican Republic" },
  "oman-esim": { "iso2s": ["OM"], "name": "Oman" },
  "mongolia-esim": { "iso2s": ["MN"], "name": "Mongolia" },
  "lesotho-esim": { "iso2s": ["LS"], "name": "Lesotho" },
  "kuwait-esim": { "iso2s": ["KW"], "name": "Kuwait" },
  "jamaica-esim": { "iso2s": ["JM"], "name": "Jamaica" },
  "brazil-esim": { "iso2s": ["BR"], "name": "Brazil" },
  "latvia-esim": { "iso2s": ["LV"], "name": "Latvia" },
  "ivory-coast-esim": { "iso2s": ["CI"], "name": "Ivory Coast" },
  "argentina-esim": { "iso2s": ["AR"], "name": "Argentina" },
  "puerto-rico-esim": { "iso2s": ["PR"], "name": "Puerto Rico" },
  "macau-esim": { "iso2s": ["MO"], "name": "Macau" },
  "bosnia-and-herzegovina-esim": { "iso2s": ["BA"], "name": "Bosnia and Herzegovina" },
  "belize-esim": { "iso2s": ["BZ"], "name": "Belize" },
  "belarus-esim": { "iso2s": ["BY"], "name": "Belarus" },
  "caribbean-island-esim": { "iso2s": ["CU", "JM", "HT", "DO", "PR", "BS", "BB", "AG", "LC", "VC", "GD", "DM", "TT", "KY", "TC", "AI", "VG", "MS", "MF", "KN", "AW", "CW", "SX", "GP", "MQ", "BL", "GF", "BZ", "GT", "HN", "SV", "NI", "CR", "PA"], "name": "Caribbean Island" },
  "uruguay-esim": { "iso2s": ["UY"], "name": "Uruguay" },
  "tanzania-esim": { "iso2s": ["TZ"], "name": "Tanzania" },
  "monaco-esim": { "iso2s": ["MC"], "name": "Monaco" },
  "malawi-esim": { "iso2s": ["MW"], "name": "Malawi" },
  "madagascar-esim": { "iso2s": ["MG"], "name": "Madagascar" },
  "jordan-esim": { "iso2s": ["JO"], "name": "Jordan" },
  "colombia-esim": { "iso2s": ["CO"], "name": "Colombia" },
  "cayman-islands-sim": { "iso2s": ["KY"], "name": "Cayman Islands" },
  "burkina-faso-esim": { "iso2s": ["BF"], "name": "Burkina Faso" },
  "bahrain-esim": { "iso2s": ["BH"], "name": "Bahrain" },
  "andorra-esim": { "iso2s": ["AD"], "name": "Andorra" },
  "africa-esim": { "iso2s": ["ZA", "EG", "MA", "KE", "NG", "TZ", "ET", "UG", "MZ", "RW", "GH", "TN", "DZ", "ZM", "MW", "MG", "MU", "SZ", "LS", "NA", "BW", "ZW", "AO", "CM", "CD", "CG", "CI", "SN", "ML", "BF", "NE", "TD", "SD", "SS", "SO", "LR", "SL", "GN", "GW", "GM", "CV", "BJ", "TG", "GA", "GQ", "CF", "DJ", "ER", "KM", "SC", "MG", "MU", "CV", "ST"], "name": "Africa" },
  "papua-new-guinea-esim": { "iso2s": ["PG"], "name": "Papua New Guinea" },
  "laos-esim": { "iso2s": ["LA"], "name": "Laos" },
  "guatemala-esim": { "iso2s": ["GT"], "name": "Guatemala" },
  "antigua-and-barbuda-esim": { "iso2s": ["AG"], "name": "Antigua and Barbuda" },
  "seychelles-esim": { "iso2s": ["SC"], "name": "Seychelles" },
  "mayotte-esim": { "iso2s": ["YT"], "name": "Mayotte" },
  "kosovo-esim": { "iso2s": ["XK"], "name": "Kosovo" },
  "greenland-esim": { "iso2s": ["GL"], "name": "Greenland" },
  "barbados-esim": { "iso2s": ["BB"], "name": "Barbados" },
  "trinidad-and-tobago-esim": { "iso2s": ["TT"], "name": "Trinidad and Tobago" },
  "san-marino-esim": { "iso2s": ["SM"], "name": "San Marino" },
  "samoa-esim": { "iso2s": ["WS"], "name": "Samoa" },
  "maldives-esim": { "iso2s": ["MV"], "name": "Maldives" },
  "lithuania-esim": { "iso2s": ["LT"], "name": "Lithuania" },
  "liechtenstein-esim": { "iso2s": ["LI"], "name": "Liechtenstein" },
  "el-salvador-esim": { "iso2s": ["SV"], "name": "El Salvador" },
  "ecuador-esim": { "iso2s": ["EC"], "name": "Ecuador" },
  "democratic-republic-of-the-congo-esim": { "iso2s": ["CD"], "name": "Democratic Republic of the Congo" },
  "brunei-esim": { "iso2s": ["BN"], "name": "Brunei" },
  "botswana-esim": { "iso2s": ["BW"], "name": "Botswana" },
  "yemen-esim": { "iso2s": ["YE"], "name": "Yemen" },
  "uganda-esim": { "iso2s": ["UG"], "name": "Uganda" },
  "sudan-esim": { "iso2s": ["SD"], "name": "Sudan" },
  "slovakia-esim": { "iso2s": ["SK"], "name": "Slovakia" },
  "saint-lucia-esim": { "iso2s": ["LC"], "name": "Saint Lucia" },
  "panama-esim": { "iso2s": ["PA"], "name": "Panama" },
  "northern-mariana-islands-esim": { "iso2s": ["MP"], "name": "Northern Mariana Islands" },
  "montserrat-esim": { "iso2s": ["MS"], "name": "Montserrat" },
  "mauritius-esim": { "iso2s": ["MU"], "name": "Mauritius" },
  "isle-of-man-esim": { "iso2s": ["IM"], "name": "Isle of Man" },
  "guyana-esim": { "iso2s": ["GY"], "name": "Guyana" },
  "estonia-esim": { "iso2s": ["EE"], "name": "Estonia" },
  "curacao-esim": { "iso2s": ["CW"], "name": "Curacao" },
  "british-virgin-islands-esim": { "iso2s": ["VG"], "name": "British Virgin Islands" },
  "vatican-city-esim": { "iso2s": ["VA"], "name": "Vatican City" },
  "vanuatu-esim": { "iso2s": ["VU"], "name": "Vanuatu" },
  "tonga-esim": { "iso2s": ["TO"], "name": "Tonga" },
  "suriname-esim": { "iso2s": ["SR"], "name": "Suriname" },
  "saint-vincent-and-the-grenadines-esim": { "iso2s": ["VC"], "name": "Saint Vincent and the Grenadines" },
  "luxembourg-esim": { "iso2s": ["LU"], "name": "Luxembourg" },
  "liberia-esim": { "iso2s": ["LR"], "name": "Liberia" },
  "guinea-bissau-esim": { "iso2s": ["GW"], "name": "Guinea-Bissau" },
  "guinea-esim": { "iso2s": ["GN"], "name": "Guinea" },
  "grenada-esim": { "iso2s": ["GD"], "name": "Grenada" },
  "gabon-sim": { "iso2s": ["GA"], "name": "Gabon" },
  "french-guiana-esim": { "iso2s": ["GF"], "name": "French Guiana" },
  "dominica-sim": { "iso2s": ["DM"], "name": "Dominica" },
  "chad-sim": { "iso2s": ["TD"], "name": "Chad" },
  "cape-verde-esim": { "iso2s": ["CV"], "name": "Cape Verde" },
  "afghanistan-esim": { "iso2s": ["AF"], "name": "Afghanistan" },
  "europe-yoho-special": { "iso2s": ["GB", "DE", "FR", "IT", "ES", "NL", "CH", "AT", "BE", "PT", "SE", "NO", "DK", "FI", "IE", "PL", "CZ", "HU", "GR", "RO", "BG", "HR", "SI", "SK", "LT", "LV", "EE", "LU", "MT", "CY", "IS", "LI", "MC", "AD", "SM", "VA"], "name": "Europe Yoho Special" },
  "turks-and-caicos-islands-esim": { "iso2s": ["TC"], "name": "Turks and Caicos Islands" },
  "eswatini-esim": { "iso2s": ["SZ"], "name": "Eswatini" },
  "saint-martin-esim": { "iso2s": ["MF"], "name": "Saint Martin" },
  "saint-kitts-and-nevis-esim": { "iso2s": ["KN"], "name": "Saint Kitts and Nevis" },
  "paraguay-esim": { "iso2s": ["PY"], "name": "Paraguay" },
  "niger-esim": { "iso2s": ["NE"], "name": "Niger" },
  "nicaragua-esim": { "iso2s": ["NI"], "name": "Nicaragua" },
  "netherlands-antilles-esim": { "iso2s": ["AW", "CW", "SX", "BQ"], "name": "Netherlands Antilles" },
  "nauru-esim": { "iso2s": ["NR"], "name": "Nauru" },
  "kiribati-esim": { "iso2s": ["KI"], "name": "Kiribati" },
  "honduras-esim": { "iso2s": ["HN"], "name": "Honduras" },
  "haiti-sim": { "iso2s": ["HT"], "name": "Haiti" },
  "guernsey-sim": { "iso2s": ["GG"], "name": "Guernsey" },
  "gibraltar-esim": { "iso2s": ["GI"], "name": "Gibraltar" },
  "bolivia-esim": { "iso2s": ["BO"], "name": "Bolivia" },
  "bermuda-esim": { "iso2s": ["BM"], "name": "Bermuda" },
  "benine-esim": { "iso2s": ["BJ"], "name": "Benin" },
  "anguilla-esim": { "iso2s": ["AI"], "name": "Anguilla" },
  "europe-esim-2": { "iso2s": ["GB", "DE", "FR", "IT", "ES", "NL", "CH", "AT", "BE", "PT", "SE", "NO", "DK", "FI", "IE", "PL", "CZ", "HU", "GR", "RO", "BG", "HR", "SI", "SK", "LT", "LV", "EE", "LU", "MT", "CY", "IS", "LI", "MC", "AD", "SM", "VA", "GI", "FO", "GL", "AX", "JE", "GG", "IM", "MQ", "GP", "RE", "YT", "MF", "BL", "PM", "WF", "PF", "NC"], "name": "Europe" },
}; 